export const features = [
  { id: 'figments', name: 'Figments' },
  { id: 'research-ca-1', name: 'MA Research - CA' },
  { id: 'research-md-1', name: 'MA Research - MD' },
  { id: 'research-va-1', name: 'MA Research - VA' },
  { id: 'research-la-1', name: 'MA Research - LA' },
]
